import { useQuery } from '@apollo/client/react/hooks/useQuery';
import { Box, H3, Icon, Link, Separator, Text } from '@betterment/samba-react';
import { ThemedImage } from '@betterment/shared-components/src/components/themed-image/ThemedImage';

import { AccountPerformanceHeaderDocument } from './graphql/accountPerformanceHeader.generated';

import { DateRangeOption } from '../../../graphql/schema';
import { urlBuilder } from '../../../Shared/urlBuilder';
import { DateRangeFilter } from '../../shared/date-range-filter/DateRangeFilter';

type HeaderProps = {
  dateRangeOption: DateRangeOption;
  accountId: string;
  setDateRangeOption: (option: DateRangeOption) => void;
};

export const Header = ({ dateRangeOption, accountId, setDateRangeOption }: HeaderProps) => {
  const { data } = useQuery(AccountPerformanceHeaderDocument, {
    variables: { accountId },
  });

  if (!data) {
    return null;
  }

  const account = data.performance.accounts[0];
  if (!account) {
    return null;
  }

  const {
    icon,
    name,
    envelope: { purpose },
  } = account;
  const purposeName = purpose?.name;

  return (
    <Box css={{ paddingY: 'space.300' }}>
      <Link
        href={urlBuilder.appPerformance.absolute()}
        css={{ display: 'flex', alignItems: 'center', gap: 'space.100', marginBottom: 'space.200' }}
      >
        <Icon name="CaretLeft" size="small" color="icon" />
        <Text color="text.weak">All performance</Text>
      </Link>
      <Box css={{ display: 'flex', gap: 'space.150' }}>
        <ThemedImage themedAsset={icon} alt={name} />
        <Box>
          <H3 variant="title300">{name}</H3>
          {purposeName && <Text color="text.weak">{purposeName}</Text>}
        </Box>
      </Box>
      <Separator css={{ fullWidthWithInset: 'space.0', marginTop: 'space.300', marginBottom: 'space.300' }} />
      <DateRangeFilter onChange={setDateRangeOption} selected={dateRangeOption} />
    </Box>
  );
};
